import { InputEditIcon } from '../../../components/Icon';


const AuthControlEditEmail = ({ value = '', isDisabled = false, onClick }) => {
    return (
        <div className='edit-email-control'>
            <input
                maxLength="150"
                disabled
                readOnly
                className="auth-input sign-in-email-step-two edit-email-control-input"
                name="email"
                type="email"
                value={value}
                autoFocus={(window.innerWidth >= 1000)}
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                spellCheck="false"
                inputMode="email"
                placeholder="Enter your email address"
                aria-label="Enter your email address"
            ></input>

            <button
                className='edit-email-control-button'
                type="button"
                disabled={isDisabled}
                onClick={onClick}
            >
                <InputEditIcon />
            </button>
        </div>
    )
};

export default AuthControlEditEmail;

